// extracted by mini-css-extract-plugin
export default {"bgImage":"assobnyak_bgImage__K7at2"};